(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["me-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('me-product-hero')) {
    customElements.define('me-product-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.token = 0;
        this.inView = false;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.userPaused = this.dataset.autoplay !== 'true';
        this.interval = Math.max(5000, Number(this.dataset.interval) || 10000);
        this.toggle = this.querySelector('[data-toggle]');
        this.status = this.querySelector('[data-status]');
        if (this.slides.length < 2) return;
        this.querySelector('.mph__controls').hidden = false;
        this.querySelector('[data-next]').addEventListener('click', () => this.manual(1), options);
        this.querySelector('[data-previous]').addEventListener('click', () => this.manual(-1), options);
        this.toggle.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.sync();
        }, options);
        this.querySelectorAll('.mph__product').forEach(link => {
          link.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, options);
          link.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
        });
        this.addEventListener('pointerdown', () => { this.focused = false; this.sync(); }, options);
        this.addEventListener('focusin', event => {
          this.focused = !this.toggle.contains(event.target) && event.target.matches(':focus-visible');
          this.sync();
        }, options);
        this.addEventListener('focusout', () => { this.focused = false; this.sync(); }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); }, { threshold: .15 });
        this.observer.observe(this);
        this.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (selected >= 0) { this.editorSelected = true; this.show(selected, true); }
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.sync(); }, options);
        this.prepare(1);
        this.sync();
      }
      prepare(index) {
        const image = this.slides[index]?.querySelector('img');
        if (image) image.loading = 'eager';
        return image;
      }
      manual(direction) {
        this.show((this.index + direction + this.slides.length) % this.slides.length, true);
      }
      async show(index, announce = false) {
        clearTimeout(this.timer);
        const token = ++this.token;
        const image = this.prepare(index);
        try { if (image) await image.decode(); } catch {
          if (!image?.complete || !image.naturalWidth) {
            if (this.isConnected && token === this.token) this.sync();
            return;
          }
        }
        if (!this.isConnected || token !== this.token) return;
        this.slides.forEach((slide, position) => {
          const active = position === index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.index = index;
        this.querySelector('[data-current]').textContent = String(index + 1);
        if (announce) this.status.textContent = this.slides[index].getAttribute('aria-label');
        this.prepare((index + 1) % this.slides.length);
        this.sync();
      }
      sync() {
        clearTimeout(this.timer);
        if (!this.toggle) return;
        this.toggle.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.toggle.querySelector('[data-toggle-icon]').textContent = this.userPaused ? '▶' : 'Ⅱ';
        if (!this.userPaused && !this.hovered && !this.focused && !this.editorSelected && this.inView && !document.hidden && this.slides.length > 1) {
          this.timer = setTimeout(() => this.show((this.index + 1) % this.slides.length), this.interval);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.token++;
        this.observer?.disconnect();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
